export default __webpack_public_path__ + "2f21ab29926e925c757c755ba2d3a4d3.jpg";